import { Component, OnInit } from '@angular/core';
import { RepositoryService } from "../../shared/services/repository.service";
import { RiskPolicyGuideline } from "../../_interfaces/RiskPolicyGuideline.model";
import { Router } from '@angular/router';
import { RiskUser } from './../../_interfaces/RiskUser.model';

@Component({
  selector: 'app-policy-guideline-list',
  templateUrl: './policy-guideline-list.component.html',
  styleUrls: ['./policy-guideline-list.component.css']
})
export class PolicyGuidelineListComponent implements OnInit {
  fileData: File = null;
  public policyDocs: RiskPolicyGuideline[];
  public user: RiskUser;

  constructor(private router: Router, private repository: RepositoryService) { }


  ngOnInit() {
    this.getPolicyDocs();
    this.user = this.repository.GetMyUser();
  }


  deletePolicyDocDetails(id: number ) {
    let PolicyDocDeleteApi: string = `PolicyDocuments/${id}`;
    this.repository.delete(PolicyDocDeleteApi)
      .subscribe(res => {
        // Update the parent dialog contents to remove the deleted Policy Doc 
        this.getPolicyDocs();

      });
  }
  onFileSelect(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (!file.name.includes(".pdf")) {
        alert('Please select a pdf file to use as evidence!! :-)\n\n');
        return;
      }
      this.fileData = file;
      let formData = new FormData();
      formData.append('file', this.fileData);
      let apiAddress: string = `PolicyDocuments`;

      this.repository.uploadFile(apiAddress, formData)
        .subscribe(res => {
          // Update the dialog contents
          this.getPolicyDocs();
        });;
    }
  }

  getPolicyDocs() {
    let apiAddress: string = `PolicyDocuments`;
    this.repository.getData(apiAddress)
      .subscribe(res => {
        this.policyDocs = res as RiskPolicyGuideline[];
      });
  }

  addPolicyGuideline() {
    let policyGuidelineIdDetailUrl: string = `/myrisks/policy-guidelines/0`; 
    this.router.navigate([policyGuidelineIdDetailUrl]);
  }

  public getPolicyDocDetails(policyGuidelineId: number) {
    let policyGuidelineIdDetailUrl: string = `/myrisks/policy-guidelines/${policyGuidelineId}`; 
    this.router.navigate([policyGuidelineIdDetailUrl]);
  }

  getPolicyGuidelineDocumentDetails(id: number) {
    // Call service to download pdf as a blob to open in a new window 
    let apiUrl: string = `PolicyDocuments/${id}/PolicyDocument`;
    let newFilename: string = `"Risk Policy Guideline ${id}.pdf`; 
    this.repository.getFileData(apiUrl)
      .subscribe(res => {
        //  download file and open it
        var file = new Blob([res], { type: "application/pdf" });

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file, newFilename);
        }
        else {
          var objectUrl = URL.createObjectURL(file);
          window.open(objectUrl);
        }
      });
  }
}
